/*eslint no-eval: 2*/

<template>
  <v-col class="mb-5" cols="6">
    <h4 style="text-decoration:underline" class="secondary-color">
      <span id="Bootstrapper" class="theme-main-color-darker">
        Set Bootsrapper Version
      </span>
    </h4>

    <div>
      <p class="text-caption">
        You can specify a specific bootstrapper version here.
        By default it will resolve to <span class="text-primary font-weight-bold">latest</span> version if nothing is specified,
        or if an invalid version is passed in.
        <span style="visibility:hidden">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</span>
      </p>
      <v-row style="margin-top:37px">
        <v-col cols="9">
          <div class="mb-2">
            <v-text-field
              v-model="bootstrapVersion"
              variant="filled"
              label="Bootstrap version"
            ></v-text-field>
          </div>
        </v-col>
        <v-col cols="3">
          <v-tooltip location="top">
            <template v-slot:activator="{ props }">
              <v-btn
                :loading="loader"
                v-bind="props"
                rounded
                variant="outlined"
                class="theme-main-bg text-white"
                icon
                @click="updateBootstrap"
              >
              <v-icon>mdi-reload</v-icon>
            </v-btn>
            </template>
            <span>Reload to update bootstrapper version</span>
        </v-tooltip>
        </v-col>
      </v-row>
    </div>

  </v-col>
</template>

<script>
import { mapMutations } from 'vuex'
import { getBootstrapVersionFromUrl } from '@/utils/helpers'
import { getIframeUrl } from '@/http/service'

export default {
  name: 'Bootstrapper-version',
  data: () => ({
    loader: false,
    bootstrapVersion: 'latest'
  }),
  methods: {
    ...mapMutations([
      'reloadCashierMutation',
      'setBootstrapVersion'
    ]),
    updateBootstrap () {
      this.loader = true
      this.checkVersion()
    },
    async checkVersion () {
      const url = `https://static.paymentiq.io/cashier/cashier.${this.bootstrapVersion}.js`
      const res = await fetch(url)
      const script = await res.text()
      this.updateScript(res.status === 200 && script)
    },
    removeScript (ID) {
      try {
        document.querySelector(`#${ID}`).remove()
      } catch (err) {
        console.log('No bootstrapper script found in DOM')
      }
    },
    async updadeBootstrapVersionInfo () {
      try {
        const bootstrapVersion = await getBootstrapVersionFromUrl(getIframeUrl)
        if (bootstrapVersion) {
          this.setBootstrapVersion(bootstrapVersion)
        }
      } catch (err) {
        console.log('Could not get bootstrap version')
      }
    },
    updateScript (script) {
      window._PaymentIQCashier_FIXED_VERSION = null
      if (script) {
        const e = eval
        window._PaymentIQCashier_FIXED_VERSION = script.replace('window._PaymentIQCashier=', 'window._PaymentIQCashier_FIXED_VERSION=')
        e(window._PaymentIQCashier_FIXED_VERSION)
      }
      this.reloadCashierMutation()
      this.loader = false
      setTimeout(() => {
        this.updadeBootstrapVersionInfo()
      }, 2500)
    }
  }
}
</script>
